import React from "react";
import Button from "../common/Button";
import { useNavigate } from "react-router-dom";

const CompetitionCard = ({ competition, isCompleted = false }) => {
  const navigate = useNavigate();
  return (
    <div className="bg-white mb-7  shadow-[0_6px_0px_0px_rgba(0,0,0,0.11)]  ">
      <div className="flex justify-between pt-12 pb-11 pl-24 pr-[62px]">
        <div className="flex gap-[90px] items-center">
          <div className="">
            <img
              src={competition.icon}
              alt={competition.title}
              className="w-[86px] h-[127px] object-contain"
            />
          </div>
          <div className=" w-full">
            <h3 className="text-[32px] font-bold  mb-7 max-w-xs  leading-[38px]">
              {competition.title}
            </h3>
           
            <p className="text-xl leading-[23px]  ">
              Hosted By : <span>{competition.hostedBy}</span>
            </p>

            <div className="flex  text-xl leading-[23px] mt-[22px] mb-3">
              <p className="max-w-[118px] w-full">Ends In</p>
              <p className=" text-[#938A96]">{competition.endsIn}</p>
            </div>
            <div className="flex  text-xl leading-[23px] mb-3">
              <p className="max-w-[118px] w-full">Team Size</p>
              <p className=" text-[#938A96]">{competition.teamSize}</p>
            </div>
            <div className="flex  text-xl leading-[23px]">
              <p className="max-w-[118px] w-full">Grade</p>
              <p className=" text-[#938A96]">{competition.grade}</p>
            </div>
          </div>
        </div>
        <div className="flex flex-col justify-between  pt-1.5 ">
          {!isCompleted ? (
            <Button
              btnText="Register & Start"
              btnClassName="text-2xl font-bold text-white bg-[#22C55E] leading-7 py-[17.5px] w-[266px]"
              onClick={() => navigate("/competition/competition-registration")}
            />
          ) : (
            <>
              <div>
                <Button
                  btnText="View Competition"
                  btnClassName="text-2xl font-bold text-[#FF6636] border border-[#FF6636] leading-7 py-[16.5px] w-[266px]"
                />
                <p className="text-[#938A96] text-center text-xl mt-6 leading-[23px]">
                  Competition has ended
                </p>
              </div>
              <p className="leading-[23px] pb-1.5 text-center text-xl">
                Prize Worth {competition.prize}
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default CompetitionCard;
